import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, LoadingController, MenuController, PopoverController } from '@ionic/angular';
import { Router, NavigationExtras } from '@angular/router';

import { ImageData } from '../../models/image-data';
import { Constants } from '../../models/constants';

import { Alert } from '../../services/alert';
import { UserService } from '../../services/user-service';
import { Util } from '../../services/util';
import { ProfPicService } from '../../services/prof-pic-service';
import { RoomTasks } from '../../services/room-tasks'
import { RegisterConciergeTasks } from '../../services/register-concierge-tasks'
import { PromoService, PromoActivation } from 'src/app/services/promo-service';
import { EventSeriesInfo } from 'src/app/models/event-series-info';
import { GiftCard, GiftCardsService } from 'src/app/services/gift-cards-service';
import { VibeToast } from 'src/app/services/vibe-toast';
import { BusinessTasks, BusinessLocation } from "../../services/business-tasks";

import { EnterAddressPage } from '../enter-address/enter-address.page';
import { AnalyticsService } from 'src/app/services/analytics-service';
import { MetaTagService } from 'src/app/services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

@Component({
  selector: 'app-register-concierge',
  templateUrl: './register-concierge.page.html',
  styleUrls: ['./register-concierge.page.scss'],
})
export class RegisterConciergePage implements OnInit {

  concierge: {
    fullName?: string;
    email?: string;
    phone?: string;
    // businessLocationID?: string;
  } = {};

  isMenuOpen = false

  commissionOptions: any[] = []
  businessLocations: BusinessLocation[] = []

  submitStatus?: string
  errorStatus?: string

  formatPercentage = Util.formatPercentage

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private profPicService: ProfPicService,
    private alert: Alert,
    private observables: ObservableService,
    private router: Router,
    private changeRef: ChangeDetectorRef,
    private popoverCtrl: PopoverController,
    public userService: UserService,
    private menuCtrl: MenuController,
    private metaTagService: MetaTagService
  ) {

    const business = this.userService.business

    if (!business) {
      const sub = this.observables.businessFetched.subscribe(() => {
        sub.unsubscribe()
        let eventualLoad = true
        this.loadUIContent(eventualLoad)
      });
      return
    }

    this.loadUIContent()
  }

  ngOnInit() {
    // this.pullBusinessLocations()
  }

  loadUIContent(eventualLoad?: boolean) {

    this.commissionOptions = this.userService.getBusinessCommissionOptions()

    if (eventualLoad) {
      this.changeRef.detectChanges()
    }
  }

  ionViewWillEnter() {
    this.metaTagService.updateTitle('Create a Concierge')
    // this.metaTagService.updateTags({
    //   facebookURL: 'https://app.getshortcut.co/account',
    //   keywords: 'account settings, profile settings, account, profile',
    //   facebookTitle: 'Account | Shortcut',
    //   twitterTitle: 'Account | Shortcut',
    //   description: 'Access and update your Shortcut account settings.',
    //   facebookDescription: 'Access and update your Shortcut account settings.',
    //   twitterDescription: 'Access and update your Shortcut account settings.',
    // })

    this.menuCtrl.enable(true);
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/register-concierge')
  }

  // private pullBusinessLocations() {

  //   BusinessTasks.pullBusinessLocations((businessLocations: BusinessLocation[]) => {

  //     this.businessLocations = businessLocations
  //     this.changeRef.detectChanges()

  //     if (!this.businessLocations.length) {
  //       this.alert.show('Please finish your profile', 'Add a business location and commission tier in Business Settings.')
  //     }

  //   }, (err: string) => {
  //     if (!Util.isNavigationError(err)) {
  //       alert(err)
  //     }
  //   })
  // }

  openPage(url: string) {
    window.open(url, '_blank')
  }

  async adminChat() {
    this.observables.publishOpenNewAdminChat();
  }

  private goToChat(roomID: string) {
    this.observables.publishOpenNewChat(roomID)
  }

  emailFromBrowser() {
    let helpEmail = 'support@getshortcut.co'
    let subject = 'Contact Shortcut'
    let body = ''
    window.location.href = 'mailto:' + helpEmail + '?subject=' + subject + '&body=' + body
  }

  interfaceOptions(headerText: string, subHeaderText: string) {
    return {
      header: headerText,
      subHeader: subHeaderText
    }
  }

  openSccToThisPage() {
    window.open(`${Constants.SCC_ADMIN_URL}/#/businessPros`, '_blank')
  }




  async submit() {

    this.errorStatus = undefined;
    this.submitStatus = undefined;

    let fullName = this.concierge.fullName;
    if (!Util.validateFullName(fullName)) {
      this.alert.show('Error', 'Please enter full name')
      return
    }

    let loading = await this.loadingCtrl.create()
    loading.present()

    RegisterConciergeTasks.registerConcierge_Business(
      this.concierge.fullName.trim(),
      this.concierge.email.trim(),
      this.concierge.phone.trim(),
      () => {
        this.concierge.fullName = ''
        this.concierge.email = ''
        this.concierge.phone = ''
        this.submitStatus = 'Concierge registered successfully.'
        loading.dismiss()
        this.changeRef.detectChanges()
      },
      (msg: string) => {
        this.errorStatus = msg
        loading.dismiss()
        this.changeRef.detectChanges()
      })
  }

}
